import styled from 'styled-components/macro'

import { TextField } from '@loadsmart/loadsmart-ui'
import { Layout } from '@loadsmart/miranda-react'
import { getToken, toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { screen } from 'legacy/styles/screen'

export const TableWrapper = styled(Layout.Group)`
  overflow-x: auto;
  width: 85vw;

  ${screen.md} {
    width: 90vw;
  }

  ${screen.lg} {
    width: 100%;
  }
`

export const StyledTextField = styled(TextField)`
  width: 100%;
`

export const AllInRateGroup = styled(Layout.Group)`
  background: ${toCSSValue('color-success-20')};
  padding: ${getToken('spacing-3')};
  margin: 0px;
`
